import {
  SaveButton,
  useNotify,
  useRecordContext,
  useRedirect
} from 'react-admin';

const SaveAndRedirectButton = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const record = useRecordContext();

  return (
    <SaveButton
      mutationOptions={{
        onSuccess: () => {
          notify('resources.creditmemos.creditmemo_created');
          redirect(`/contracts/${record.contract_id}/show`);
        },
      }}
      type="button"
      alwaysEnable
    />
  );
};
export default SaveAndRedirectButton;
